import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function mediaUrl(v) {
  if (!v) return "";
  return v.startsWith("http") || v.startsWith("data:") ? v : `${BACKEND_URL}${v}`;
}

// Resolves a media path to a loadable URL. Backend-stored uploads (/api/...) get the
// backend origin; frontend static assets (/images, /videos) and absolute URLs pass through.
export function assetUrl(v) {
  if (!v) return "";
  if (v.startsWith("http") || v.startsWith("data:")) return v;
  if (v.startsWith("/api/")) return `${BACKEND_URL}${v}`;
  return v;
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dde_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
